/**
 * Creates an empty TagFilter with no constraints.
 */
export function emptyTagFilter() {
    return {
        include: [],
        exclude: [],
    };
}
/**
 * Checks if a TagFilter has any active constraints.
 */
export function hasActiveFilter(filter) {
    if (!filter)
        return false;
    return filter.include.length > 0 || filter.exclude.length > 0;
}
//# sourceMappingURL=TagFilter.js.map